<template>
  <v-card class="ma-3">
    <v-card-title>
      <h2>{{ title }}</h2>
    </v-card-title>
    <v-layout row justify-end wrap class="mb-5">
      <v-flex xs12 md2>
        <div class="ml-3">
          <v-autocomplete
            color="primary"
            v-model="filters.company"
            :items="companiesList"
            :label="$t('Empresas')"
            item-text="text"
            item-value="value"
            clearable
          ></v-autocomplete>
        </div>
      </v-flex>
      <v-flex xs12 md2>
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.consultant"
            item-text="text"
            item-value="user_id"
            :items="consultantsList"
            :clearable="true"
            row
            :label="$t('Gestor/a')"
          >
            <template slot="item" slot-scope="data">
              <div :class="{ 'bg-inactive': data.item.inactive }">
                {{ data.item.text }}
              </div>
            </template>
          </v-select>
        </div>
      </v-flex>
      <v-flex xs12 md2>
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.status"
            item-text="text"
            item-value="value"
            :items="[{ text: 'Activo', value: 'active' }, { text: 'Inactivo', value: 'inactive' }]"
            :clearable="true"
            row
            :label="$t('Estado')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md6>
        <div class="ml-3 mr-3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-if="!loading" v-model="formCustomerUserDialog" max-width="650px">
      <customer-user-form
        v-if="readyToEditUser && formCustomerUserDialog"
        :edit-index="editedIndex"
        :edit-item="editedItem"
        @closeDialog="formCustomerUserDialog = false"
        @profileSaved="profileSaved"
        @removeConsultant="removeConsultant($event)"
      ></customer-user-form>
      <!-- <customer-data-form v-if="profile == 'customer' && configLoaded" :config="config" :edit-index="editedIndex" :edit-item="editedItem"  @closeDialog="closeDialog" @profileSaved="profileSaved"></customer-data-form>
            <consultant-form :key="consultantFormKey" v-if="profile == 'consultant' && !loading" :edit-index="editedIndex" :edit-item="editedItem" @closeDialog="closeDialog" @profileSaved="profileSaved"></consultant-form> -->
    </v-dialog>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :pagination.sync="pagination"
      :rows-per-page-items="[10, 20, 30, 50, 100]"
      :total-items="pagination.totalItems"
    >
      <template slot="items" slot-scope="props">
        <td v-for="col of headers" :key="col.value">
          <template v-if="!Array.isArray(props.item[col.value])">
            <template v-if="col.value === 'premium'">
              <v-chip v-if="props.item['premium']" small color="secondary" text-color="black">
                {{ props.item['premium'] ? 'SÍ' : '' }}
              </v-chip>
            </template>
            <template v-else-if="col.value === 'non_payment'">
              <v-chip v-if="props.item['non_payment']" small color="error" text-color="white">
                {{ props.item['non_payment'] ? 'SÍ' : '' }}
              </v-chip>
            </template>
            <template v-else-if="col.value == 'action'">
              <!-- <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon> -->
              <div class="text-xs-right">
                <template v-if="!userIsSuperAdmin(props.item)">
                  <v-tooltip v-if="userIsLoggeable(props.item)" top>
                    <v-icon
                      slot="activator"
                      small
                      class="mr-2"
                      color="grey"
                      @click="connectAs(props.item)"
                    >
                      mdi-account-convert
                    </v-icon>
                    <span>{{ $t('Connect as user') }}</span>
                  </v-tooltip>

                  <v-tooltip v-else top>
                    <v-icon
                      slot="activator"
                      small
                      class="mr-2"
                      color="grey lighten-2"
                      @click="connectAs(props.item)"
                    >
                      mdi-account-off
                    </v-icon>
                    <span>{{ $t('Desactivated user') }}</span>
                  </v-tooltip>
                </template>

                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    small
                    class="mr-2"
                    :color="props.item.customer_profile ? 'grey' : 'grey lighten-2'"
                    @click="
                      props.item.customer_profile ? editUser(props.item) : userInfo(props.item)
                    "
                  >
                    mdi-account-edit
                  </v-icon>
                  <span>{{ $t('Edit user') }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    color="error"
                    v-if="!props.item['trash']"
                    small
                    @click="deleteItem(props.item)"
                  >
                    delete
                  </v-icon>
                  <span>{{ $t('Delete user') }}</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    color="primary"
                    v-if="props.item['trash']"
                    small
                    @click="restoreItem(props.item)"
                  >
                    mdi-delete-restore
                  </v-icon>
                  <span>{{ $t('Restore user') }}</span>
                </v-tooltip>
              </div>
            </template>

            <template v-else>
              {{ props.item[col.value] }}
            </template>
          </template>
          <template v-if="Array.isArray(props.item[col.value])">
            <template v-if="col.value === 'premium'">
              <v-chip v-if="props.item['premium']" small color="secondary" text-color="black">
                {{ props.item['premium'] ? 'SÍ' : '' }}
              </v-chip>
            </template>
            <template v-if="col.value === 'non_payment'">
              <v-chip v-if="props.item['non_payment']" small color="error" text-color="white">
                {{ props.item['non_payment'] ? 'SÍ' : '' }}
              </v-chip>
            </template>
            <template v-else-if="col.value === 'companies'">
              <v-chip
                v-for="ob of props.item[col.value]"
                :key="ob"
                small
                color="primary"
                text-color="white"
              >
                {{ ob }}
              </v-chip>
            </template>
            <template v-else v-for="ob of props.item[col.value]">
              {{ ob }} &nbsp;
            </template>
          </template>
        </td>
      </template>
      <template slot="no-data">
        <v-btn color="primary" @click="initialize">{{ $t('Reset') }}</v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
// import ProfileAPI from '@/services/api/profile.js';
import ApiCtrl from '../../../../../services/api/abstract/abstract-api.js';
// import CustomerModel from '../../models/customer.js';
// import ConsultantModel from '../../models/consultant.js';
// import CustomerForm from "./CustomerForm.vue";

import CustomerUserForm from '@/modules/admin/aplifisa/components/CustomerUserForm.vue';
import EmpresaAPI from '../../../aplifisa/services/fiscal';
import ConsultantAPI from '../../services/consultantAPI';

// import ConsultantForm from "./ConsultantForm.vue";
// import CustomerDataForm from "./CustomerDataForm.vue";
export default {
  components: {
    // CustomerForm,
    // ConsultantForm,
    // CustomerDataForm,
    CustomerUserForm,
  },
  props: ['title', 'profile'],
  data() {
    return {
      formCustomerUserDialog: false,
      readyToEditUser: false,
      search: '',
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      loading: true,
      items: [],
      formDialog: false,
      editedItem: {},
      editedIndex: null,
      config: {},
      configLoaded: false,
      consultantFormKey: 0,
      headers: [],
      filters: {
        company: null,
        consultant: null,
        status: null,
      },
      companiesList: [],
      consultantsList: [],
    };
  },

  mounted() {
    this.initialize();
    this.getCompaniesList();
    this.getConsultantsList();
  },
  computed: {
    currentPage() {
      return this.pagination.page;
    },
    perPage() {
      return this.pagination.rowsPerPage;
    },
    filterByCompany() {
      return this.filters.company;
    },
    filterByConsultant() {
      return this.filters.consultant;
    },
    filterByStatus() {
      return this.filters.status;
    },
  },
  methods: {
    userIsLoggeable(user) {
      if (!user) {
        return false;
      }
      if (user.hasOwnProperty('consultant_profile') && user.consultant_profile) {
        return true;
      }

      if (
        user.hasOwnProperty('customer_profile') &&
        user.customer_profile &&
        user.customer_profile.hasOwnProperty('fiscal_data') &&
        user.customer_profile.fiscal_data &&
        user.customer_profile.fiscal_data.length
      ) {
        return true;
      }
      if (
        user.hasOwnProperty('roles') &&
        user.roles
          .map(x => {
            return x.name;
          })
          .includes('lopd')
      ) {
        return true;
      }

      return false;
    },
    userIsSuperAdmin(user) {
      if (!user) {
        return false;
      }
      return (
        user.hasOwnProperty('roles') &&
        user.roles
          .map(x => {
            return x.name;
          })
          .includes('superadmin')
      );
    },
    initialize() {
      this.loading = true;

      // this.editedItem = this.getEmptyProfileModel();
      this.getItems();
      this.getConfig();
    },

    getItems() {
      this.loading = true;

      const config = {
        params: {
          page: this.pagination.page,
          per_page: this.pagination.rowsPerPage,
          search: this.search,
          consultant: this.filterByConsultant,
          company: this.filterByCompany,
          status: this.filterByStatus,
        },
      };

      ApiCtrl.get('/user', config).then(response => {
        // // console.log(response);
        this.items = response.data.data;

        this.structure = response.data.structure;
        this.headers = response.data.dataTable.headers;

        this.pagination = {
          descending: this.pagination.descending,
          page: response.data.meta.current_page,
          rowsPerPage: Number(response.data.meta.per_page), // -1 for All",
          sortBy: this.pagination.sortBy,
          totalItems: Number(response.data.meta.total),
        };

        this.loading = false;
      });
    },

    getItemsIfStopChanging() {
      this.loading = true;
      const params = {
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage,
        search: this.search,
        consultant: this.filterByConsultant,
        company: this.filterByCompany,
        status: this.filterByStatus,
      };

      setTimeout(() => {
        if (
          params.page === this.pagination.page &&
          params.per_page === this.pagination.rowsPerPage &&
          params.search === this.search &&
          params.consultant === this.filterByConsultant &&
          params.company === this.filterByCompany &&
          params.status === this.filterByStatus
        ) {
          this.getItems();
        }
      }, 300);
    },

    getConfig() {
      this.configLoaded = false;
      ApiCtrl.get('/config/user').then(res => {
        // console.log({ config: res });
        this.config = res.data.data;
        this.configLoaded = true;
      });
    },

    connectAs(item) {
      // console.log(item);
      ApiCtrl.post('/user/connect-as-user', { user_id: item.id }).then(res => {
        console.log('connect_as:', res);
        const token = 'Bearer ' + res.data.token;
        const original_token = res.data.original_token;
        if (!!token && !!original_token) {
          this.$store.commit('set_admin_original_token', original_token);
          this.$store.dispatch('loginFromToken', token).then(res => {
            // console.log({loginFromToken: res});
            this.$router.go('/dashboard');
          });
        }
      });
    },

    editItem(item) {
      // console.log({ EDIT_ITEM: item });
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // this.$emit('editItem', this.editedItem);
      this.consultantFormKey = this.consultantFormKey + 1;
      this.formDialog = true;
    },

    addNew() {
      this.editedIndex = null;
      // this.editedItem = this.getEmptyProfileModel();
      this.formDialog = true;
    },

    deleteItem(item) {
      confirm(this.$t('Are you sure you want to delete this item?')) &&
        ApiCtrl.delete('/user/' + item.id).then(res => {
          // console.log(res);
          this.initialize();
        });
    },

    restoreItem(item) {
      confirm(this.$t('Are you sure you want to restore this item?')) &&
        ApiCtrl.post('/user/restore/' + item.id).then(res => {
          // console.log(res);
          this.initialize();
        });
    },
    profileSaved() {
      // if(data.index) {
      //     this.items.splice(data.index, 1, data.profile);
      // } else {
      //     this.items.push(data.profile);
      // }
      this.initialize();
      this.formCustomerUserDialog = false;
    },
    closeDialog(closeDialog) {
      if (closeDialog) {
        this.formDialog = false;
        //    this.editedItem = this.getEmptyProfileModel();
      }
    },
    userInfo(item) {
      console.log(item);
    },

    editUser(item) {
      // console.log(item);
      this.readyToEditUser = false;

      this.editedItem = null;
      // this.editedIndex = this.items.indexOf(item);
      // this.clavedat = item.CLAVEDAT;
      // if(item.customer) {
      //     console.log('INITIAL CUSTOMER');
      //     console.log(item.customer);
      //     this.initialCustomer = item.customer.id;

      // }
      // // console.log({item: item, editedIndex: this.editedIndex, clavedat: item.CLAVEDAT});
      // // this.editedindex =  Object.assign({}, item);
      // // this.$emit('editItem', this.editedItem);
      this.editedItem = item.customer_profile;
      this.editedItem.roles = [];
      for (let i = 0; i < item.roles.length; i++) {
        const roleObj = item.roles[i];
        this.editedItem.roles.push(roleObj.name);
      }

      this.editedItem.consultants = item.consultants;
      // this.editedItem.roles = item.roles;
      this.readyToEditUser = true;

      this.formCustomerUserDialog = true;
    },
    removeConsultant($event) {
      const index = this.editedItem.consultants.findIndex(
        consultant => consultant.id === $event.id,
      );
      this.editedItem.consultants.splice(index, 1);
    },
    getCompaniesList() {
      EmpresaAPI.getFiscalDataInputSelect().then(response => {
        this.companiesList = response.data;
      });
    },
    getConsultantsList() {
      ConsultantAPI.getConsultantInputSelect().then(response => {
        this.consultantsList = response.data;
      });
    },
  },
  watch: {
    search: function() {
      if (this.currentPage === 1) {
        this.getItemsIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    currentPage: function() {
      this.getItemsIfStopChanging();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getItemsIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    filterByCompany: function() {
      if (this.currentPage === 1) {
        this.getItemsIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    filterByConsultant: function() {
      if (this.currentPage === 1) {
        this.getItemsIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    filterByStatus: function() {
      if (this.currentPage === 1) {
        this.getItemsIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
  },
};
</script>
<style scoped>
.bg-inactive {
  background-color: pink;
}
</style>
